import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { captureException } from "@sentry/react";
import errorImg from "../../../assets/error.jpeg";

interface APIError extends Error {
  response?: {
    data?: {
      message?: string;
    };
  };
}

function ErrorFallback({ error }: { error: unknown }) {
  const apiError = error as APIError;

  // The react-error-boundary boundaries catch React render errors before they
  // reach Sentry's global handler, so report them explicitly. No-ops when
  // Sentry is not initialized (localdev / MSW / tests).
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <Box
      data-testid="error-fallback-page"
      sx={{ height: "75vh" }}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h2">Oops!</Typography>
      <img src={errorImg} alt="decorative error" />
      <Typography variant="h5">
        {apiError.response?.data?.message ||
          apiError.message ||
          "An error occurred"}
      </Typography>
    </Box>
  );
}

export default ErrorFallback;
